import React, { forwardRef } from "react";

const Input = forwardRef(
  (
    {
      label,
      helper,
      error,
      className = "",
      endAdornment,
      required,
      ...props
    },
    ref,
  ) => {
  const { type, inputMode, enterKeyHint, pattern, ...restProps } = props;

  const isNumericField = type === "number";
  const resolvedType = isNumericField ? "text" : type;

  const resolvedInputMode =
    inputMode ||
    (isNumericField
      ? "decimal"
      : type === "email"
        ? "email"
        : type === "tel"
          ? "tel"
          : type === "search"
            ? "search"
            : "text");

  const resolvedEnterKeyHint =
    enterKeyHint || (type === "search" ? "search" : "done");
  const resolvedPattern =
    pattern || (isNumericField ? "[0-9]*[.]?[0-9]*" : undefined);

    return (
      <label className="flex flex-col gap-2 text-sm text-slate-600 dark:text-slate-400">
        <span>
          {label}
          {required ? <span className="ml-1 text-rose-600">*</span> : null}
        </span>
        <div className="relative">
          <input
            ref={ref}
            className={[
              "h-11 w-full rounded-lg border px-4 text-base text-slate-900 dark:text-slate-100 bg-white dark:bg-slate-700 shadow-sm",
              "outline-none transition",
              endAdornment ? "pr-14" : "",
              error
                ? "border-rose-300 dark:border-rose-600 focus:border-rose-400 dark:focus:border-rose-500"
                : "border-slate-200 dark:border-slate-600 focus:border-slate-400 dark:focus:border-slate-500",
              className,
            ]
              .filter(Boolean)
              .join(" ")}
            type={resolvedType}
            inputMode={resolvedInputMode}
            enterKeyHint={resolvedEnterKeyHint}
            pattern={resolvedPattern}
            required={required}
            {...restProps}
          />
          {endAdornment && (
            <div className="absolute inset-y-0 right-3 flex items-center">
              {endAdornment}
            </div>
          )}
        </div>
        {helper && !error && (
          <span className="text-xs text-slate-500 dark:text-slate-400">
            {helper}
          </span>
        )}
        {error && (
          <span className="text-xs text-rose-600 dark:text-rose-400">
            {error}
          </span>
        )}
      </label>
    );
  },
);

export default Input;
